import { mediaForObjectSyntax } from '../..';
export const getColor = (key, theme) => {
  if (key) {
    if (typeof key === 'string') {
      var _theme$colors$brand$k;
      return (_theme$colors$brand$k = theme.colors.brand[key]) === null || _theme$colors$brand$k === void 0 ? void 0 : _theme$colors$brand$k[100];
    }
    return theme.colors.tints[key[0]][key[1]];
  }
  return undefined;
};
export const textBaseStyles = props => ({
  color: getColor(props.color, props.theme),
  fontSize: props.theme.fonts.sizes.text[props.sizeFont[0]],
  lineHeight: props.theme.lineHeight[props.lineHeight[0]],
  display: props.clampLines ? '-webkit-box' : undefined,
  '-webkit-line-clamp': props.clampLines ? `${props.clampLines}` : undefined,
  // Circumvent automatic adding of unit to number
  '-webkit-box-orient': props.clampLines ? 'vertical' : undefined,
  overflow: !!props.clampLines || props.truncate ? 'hidden' : undefined,
  maxHeight: props.clampMaxHeight,
  whiteSpace: props.truncate ? 'nowrap' : undefined,
  textOverflow: props.truncate ? 'ellipsis' : undefined,
  [mediaForObjectSyntax.tabletAndUp]: {
    fontSize: props.sizeFont[1] ? props.theme.fonts.sizes.text[props.sizeFont[1]] : undefined,
    lineHeight: props.lineHeight[1] ? props.theme.lineHeight[props.lineHeight[1]] : undefined
  },
  [mediaForObjectSyntax.tabletWideAndUp]: {
    fontSize: props.sizeFont[2] ? props.theme.fonts.sizes.text[props.sizeFont[2]] : undefined,
    lineHeight: props.lineHeight[2] ? props.theme.lineHeight[props.lineHeight[2]] : undefined
  },
  [mediaForObjectSyntax.desktopAndUp]: {
    fontSize: props.sizeFont[3] ? props.theme.fonts.sizes.text[props.sizeFont[3]] : undefined,
    lineHeight: props.lineHeight[3] ? props.theme.lineHeight[props.lineHeight[3]] : undefined
  },
  [mediaForObjectSyntax.largeDesktop]: {
    fontSize: props.sizeFont[4] ? props.theme.fonts.sizes.text[props.sizeFont[4]] : undefined,
    lineHeight: props.lineHeight[4] ? props.theme.lineHeight[props.lineHeight[4]] : undefined
  }
});